import { TableCell } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";

const TableHeading = () => {
  return (
    <TableHeader>
      <TableCell align="left">S.No.</TableCell>
      <TableCell align="left">Category Name</TableCell>
      <TableCell align="left">Parent Category</TableCell>
      <TableCell align="left">Type</TableCell>
      <TableCell align="left">Status</TableCell> 
      <TableCell align="right">Action</TableCell>
    </TableHeader>
  );
};

export default TableHeading;
